import { cn } from './cn';
import { FC } from 'react';

export const TikTokIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-22 fill-current', className)}
    >
      <path d="M13.57,4h-2.24v9.51c0,1.25-.9,2.05-1.98,2.05s-2.06-.8-2.06-2.05c0-1.44,1.13-2.2,2.63-2.04v-2.41c-.22-.04-.44-.05-.62-.05-2.46,0-4.51,1.97-4.51,4.42,0,2.59,2.03,4.57,4.53,4.57,2.19,0,4.51-1.61,4.51-4.65v-4.95c.97.97,2.14,1.27,3.4,1.27v-2.23c-1.55-.11-3.27-1.13-3.65-3.45h0Z" />
    </svg>
  );
};
